import { render } from "./TitleComponent.vue?vue&type=template&id=4a66d743&scoped=true"
import script from "./TitleComponent.vue?vue&type=script&lang=js"
export * from "./TitleComponent.vue?vue&type=script&lang=js"

import "./TitleComponent.vue?vue&type=style&index=0&id=4a66d743&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a66d743"]])

export default __exports__